import React, { PropTypes } from 'react';
import classnames from 'classnames';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';
import Home from 'marketing/about/home';
import Jobs from 'marketing/about/jobs';
import Team from 'marketing/about/team';
import Press from 'marketing/about/press';
import Affiliates from 'marketing/about/affiliates';
import { connect } from 'react-redux';

const About = ({ children, route }) => (
  <div id="content" className={classnames('l-content', route.pageClass)}>
    { children }
  </div>
);

About.propTypes = {
  children: PropTypes.any,
};

const Partners = () => (
  <div>
    <Meta
      title="Partners"
      meta={[
        { name: 'robots', content: 'noindex,follow' },
        { name: 'description', content: "Partners of crowdspring, the world's #1 marketplace for logo design, web design, and crowdsourced writing projects." },
        { name: 'keywords', content: 'crowdsource, contests, design contests, writing contests, copywriting, design, crowdsourcing' }
      ]}
      link={[{ rel: 'canonical', href: getCanonicalURL('/partners/') }]}
    />
    <div className="row columns">
      <h2>Partners</h2>
    </div>
    <section className="block">
      <div className="row">
        <div className="columns small-16 large-12">
          <h3>
            <a href="https://www.aliexpress.com/" target="_BLANK">
          AliExpress
            </a>
          </h3>
          <p>
        AliExpress is a global retail marketplace offering quality products at factory prices in small quantity. AliExpress is owned by The Alibaba Group, one of the largest and most successful e-commerce companies in the world.
          </p>
          <p>
            <a href="https://www.aliexpress.com/" target="_BLANK" className="btn btn-secondary">
          Visit Alixpress
            </a>
          </p>
        </div>
      </div>
    </section>
    <section className="block">
      <div className="row">
        <div className="columns small-16 large-12">
          <h3>
            <a href="http://www.nase.org/" target="_BLANK">
              National Association for the Self-Employed
            </a>
          </h3>
          <p>
            You may be in business on your own. But with the NASE, you aren’t all alone. Instead, you have the backing of the premier association for sole proprietors, supporting you with educational resources, legislative advocacy and consolidated buying power.
          </p>
          <p>
            You like running your business solo. Or maybe you have visions of growing into an international corporation. Either way, the NASE has products and services that can help you achieve your goals. From business and financial consultants on hand 24-hours a day to answer your questions, to life insurance coverage – included at no cost Gold members – the NASE has you covered.
          </p>
          <p>
            <a className="btn btn-secondary" href="http://www.nase.org/" target="_BLANK">
              Join NASE
            </a>
          </p>
        </div>
      </div>
    </section>
    <section className="block">
      <div className="row">
        <div className="columns small-16 large-12">
          <h3>
            <a href="https://www.bizfilings.com/" target="_BLANK">
              BizFilings
            </a>
          </h3>
          <p>
            BizFilings is the online incorporation provider of choice for more than 500,000 small businesses across the United States. BizFilings’ expert staff, step-by-step processes, and no hidden fees policy allow small business owners to form a corporation, limited liability company (LLC) or other business structure with confidence. BizFilings also offers a full range of business filing and compliance products, including Registered Agent services in all 50 states equipped with knowledgeable staff and tools to help businesses remain in compliance with state regulations.
          </p>
          <p>
            <a href="https://www.bizfilings.com/" target="_BLANK" className="btn btn-secondary">
              Create Your Business
            </a>
          </p>
        </div>
      </div>
    </section>
  </div>
);

const mapStateToProps = state => state.categories;

export { Home, Team, Jobs, Press, Partners, Affiliates };
export default connect(mapStateToProps)(About);



// WEBPACK FOOTER //
// ./marketing/about/index.jsx